import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { Badge, IconButton, Tooltip } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  getUserNotifications,
  markNotificationRead,
} from '../../modules/notification';
import NotificationsDrawer from './NotificationsDrawer';
import ForceRefreshModal from '../elements/ForceRefreshModel';
import { tokens } from '../../mui-theme';

const UserNotifications = ({ navHeight = 56, iconButtonSx }) => {
  const [notifications, setNotifications] = useState([]);
  const [totalUnRead, setTotalUnRead] = useState(0);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [refreshNotification, setRefreshNotification] = useState(null);

  const fetchNotifications = async () => {
    try {
      setLoading(true);
      const response = await getUserNotifications(0, 5);
      setNotifications(response.notifications);
      setTotalUnRead(response.total_unread);
      const refreshNotif = response.notifications.find(
        (n) =>
          (n.type === 'refresh_required' || n.type === 'system-update') &&
          n.status === 'unread',
      );
      setRefreshNotification(refreshNotif || null);
    } catch (error) {
      console.error('Error fetching notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 300000);
    return () => clearInterval(interval);
  }, []);

  const handleRefreshConfirm = async () => {
    const notif = refreshNotification;
    setRefreshNotification(null);
    if (notif) await markNotificationRead(notif.id);
    window.location.reload();
  };

  const handleCancelConfirm = async () => {
    setRefreshNotification(null);
    if (refreshNotification) await markNotificationRead(refreshNotification.id);
  };

  return (
    <>
      <Tooltip title="Notifications" arrow>
        <IconButton
          onClick={() => setDrawerOpen(true)}
          aria-label="Notifications"
          disableRipple
          sx={iconButtonSx ? iconButtonSx(drawerOpen) : {
            color: drawerOpen ? tokens.colors.primary[500] : tokens.colors.neutral[500],
            borderRadius: `${tokens.radius.sm}px`,
            p: '7px',
            backgroundColor: drawerOpen ? tokens.colors.primary[50] : 'transparent',
            transition: 'background 0.15s, color 0.15s',
            '&:hover': {
              backgroundColor: tokens.colors.primary[50],
              color: tokens.colors.primary[500],
            },
          }}>
          <Badge badgeContent={totalUnRead} color="error">
            <NotificationsOutlinedIcon sx={{ fontSize: 20 }} />
          </Badge>
        </IconButton>
      </Tooltip>

      <NotificationsDrawer
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        notifications={notifications}
        totalUnRead={totalUnRead}
        loading={loading}
        fetchNotifications={fetchNotifications}
        topOffset={navHeight}
      />

      {refreshNotification && (
        <ForceRefreshModal
          open={Boolean(refreshNotification)}
          title={refreshNotification?.title}
          message={refreshNotification?.body}
          onConfirm={handleRefreshConfirm}
          onClose={handleCancelConfirm}
          hideCancel={refreshNotification?.type === 'system-update'}
        />
      )}
    </>
  );
};

export default UserNotifications;